import {getFunctions,httpsCallable} from 'firebase/functions';
import FormularioPaquete from './FormularioPaquete';
import {TIPOS_PAQUETE,datosPaquete} from '../../../utils/paqueteFormulario';
import React, { useEffect, useMemo, useState } from 'react';
import './PaquetesReserva.css';
import { db } from '../../../firebase/firebaseConfig';
import { addDoc, collection, deleteDoc, doc, orderBy, query, serverTimestamp, updateDoc } from 'firebase/firestore';
import { getDocs } from '../../../utils/firestoreRead';

const TIPOS=TIPOS_PAQUETE;
const recintosApi=async data=>(await httpsCallable(getFunctions(),'gestionarRecinto')(data)).data;

function chip(label) {
  return <span className="pr-chip" key={label}>{label}</span>;
}

export default function PaquetesReserva() {
  const [paquetes, setPaquetes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const [busy,setBusy]=useState(false);
  const [recintos,setRecintos]=useState([]),[errorRecintos,setErrorRecintos]=useState('');
  useEffect(()=>{let live=true;recintosApi({accion:'listar'}).then(r=>{if(live)setRecintos(r.recintos||[]);}).catch(e=>{if(live)setErrorRecintos(e.message||'No se pudieron cargar los recintos.');});return()=>{live=false;};},[]);
  const cargarPlano=async(recintoId,version)=>{const meta=await recintosApi({accion:'abrir',recintoId});return {...await recintosApi({accion:'version',recintoId,version}),versiones:meta.versiones||[]};};
  const [open, setOpen] = useState(false);
  useEffect(()=>{if(!open)return;const previous=document.body.style.overflow;document.body.style.overflow='hidden';return()=>{document.body.style.overflow=previous;};},[open]);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({
    nombre: '',
    precioInput: '',
    consumoInput: '',
    cantidadEntradas: '0',
    orden: '10',
    activo: true,
    aplicaA: [],
    aplicacionRecinto:null,
    incluye: '',
  });

  const paquetesRef = useMemo(() => collection(db, 'paquetesReserva'), []);

  const cargar = async () => {
    setLoading(true);
    setError('');
    try {
      const q = query(paquetesRef, orderBy('orden', 'asc'));
      const snap = await getDocs(q);
      const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      setPaquetes(list);
    } catch (e) {
      console.error(e);
      setError('No se pudieron cargar los paquetes.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const abrirNuevo = () => {
    setEditId(null);
    setForm({
      nombre: '',
      precioInput: '',
    consumoInput: '',
    cantidadEntradas: '0',
      orden: '10',
      activo: true,
      aplicaA: [],
    aplicacionRecinto:null,
      incluye: '',
    });
    setOpen(true);
  };

  const abrirEditar = (p) => {
    setEditId(p.id);
    setForm({
      nombre: p.nombre || '',
      precioInput: p.precioCentavos === undefined ? '' : String(p.precioCentavos / 100),
      consumoInput: p.consumoCentavos === undefined ? '' : String(p.consumoCentavos / 100),
      cantidadEntradas: String(p.cantidadEntradas ?? ''),
      orden: String(p.orden ?? 10),
      activo: typeof p.activo === 'boolean' ? p.activo : true,
      aplicaA: Array.isArray(p.aplicaA) && p.aplicaA.length ? p.aplicaA : ['LOUNGE'],
      aplicacionRecinto:p.aplicacionRecinto||null,
      incluye: Array.isArray(p.incluye)
        ? p.incluye.join('\n')
        : (p.incluye || ''),
    });
    setOpen(true);
  };

  const cerrar = () => {
    if(busy)return;
    setOpen(false);
    setError('');
  };

  const guardar = async () => {
    setError('');setBusy(true);
    try {
      const payload={...datosPaquete(form),updatedAt:serverTimestamp()};
      if(!editId)await addDoc(paquetesRef,{...payload,createdAt:serverTimestamp()});
      else await updateDoc(doc(db,'paquetesReserva',editId),payload);
      await cargar();setOpen(false);
    }catch(e){setError(e.message||'No se pudo guardar el paquete.');}
    finally{setBusy(false);}
  };

  const cambiarActivo = async (p) => {
    try {
      await updateDoc(doc(db, 'paquetesReserva', p.id), {
        activo: !p.activo,
        updatedAt: serverTimestamp(),
      });
      setPaquetes((prev) => prev.map((x) => (x.id === p.id ? { ...x, activo: !p.activo } : x)));
    } catch (e) {
      console.error(e);
      alert('No se pudo actualizar el estado.');
    }
  };

  const eliminar = async (p) => {
    if (!window.confirm(`¿Eliminar el paquete "${p.nombre}"?\n\nRecomendación: si ya fue usado, mejor desactívalo.`)) {
      return;
    }
    try {
      await deleteDoc(doc(db, 'paquetesReserva', p.id));
      setPaquetes((prev) => prev.filter((x) => x.id !== p.id));
    } catch (e) {
      console.error(e);
      alert('No se pudo eliminar.');
    }
  };

  return (
    <div className="pr-page">
      <div className="pr-header">
        <div>
          <div className="pr-title">Paquetes de reserva</div>
        </div>
        <button className="pr-primary" onClick={abrirNuevo}>+ Nuevo paquete</button>
      </div>

      {loading && <div className="pr-card">Cargando paquetes…</div>}
      {!loading && error && <div className="pr-error">{error}</div>}

      {!loading && !error && (
        <div className="pr-tableWrap">
          <table className="pr-table">
            <thead>
              <tr>
                <th>Orden</th>
                <th>Nombre</th>
                <th>Aplica a</th>
                <th>Precio</th>
                <th>Estado</th>
                <th style={{ width: 220 }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {paquetes.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ padding: 16, opacity: 0.85 }}>
                    No hay paquetes aún. Crea el primero con “Nuevo paquete”.
                  </td>
                </tr>
              ) : (
                paquetes.map((p) => (
                  <tr key={p.id}>
                    <td data-label="Orden">{p.orden ?? ''}</td>
                    <td data-label="Nombre">
                      <div className="pr-name">{p.nombre}</div><div>Entradas: {p.cantidadEntradas ?? 'pendiente de configurar'}</div>
                      {Array.isArray(p.incluye) && p.incluye.length > 0 && (
                        <div className="pr-incluye">Incluye: {p.incluye.join(' · ')}</div>
                      )}
                    </td>
                    <td data-label="Aplica a">
                      <div className="pr-chips">
                        {p.aplicacionRecinto?.resumen?.length?p.aplicacionRecinto.resumen.map(chip):(p.aplicaA || []).map((t) => chip(TIPOS.find((x) => x.id === t)?.label || t))}
                      </div>
                    </td>
                    <td data-label="Precio">{Number(p.precioCentavos || 0) / 100} Bs<div className="pr-incluye">Consumo: {p.consumoCentavos === undefined ? 'Pendiente de configurar' : (p.consumoCentavos / 100).toFixed(2) + ' Bs'}</div>{p.consumoCentavos !== undefined && p.cantidadEntradas > 0 && <div className="pr-incluye">Por entrada: {((p.precioCentavos - p.consumoCentavos) / p.cantidadEntradas / 100).toFixed(2)} Bs</div>}</td>
                    <td data-label="Estado">
                      <span className={p.activo ? 'pr-pill pr-pill--on' : 'pr-pill pr-pill--off'}>
                        {p.activo ? 'Activo' : 'Inactivo'}
                      </span>
                    </td>
                    <td data-label="Acciones">
                      <div className="pr-actions">
                        <button className="pr-btn" onClick={() => abrirEditar(p)}>Editar</button>
                        <button className="pr-btn" onClick={() => cambiarActivo(p)}>
                          {p.activo ? 'Desactivar' : 'Activar'}
                        </button>
                        <button className="pr-btn pr-btn--danger" onClick={() => eliminar(p)}>Eliminar</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {open && (
        <div className="pr-modalOverlay" onClick={cerrar}>
          <div className="pr-modal" role="dialog" aria-modal="true" aria-label={editId?'Editar paquete':'Nuevo paquete'} onClick={(e) => e.stopPropagation()}>
            <div className="pr-modalHead">
              <div className="pr-modalTitle">{editId ? 'Editar paquete' : 'Nuevo paquete'}</div>
              <button className="pr-x" aria-label="Cerrar paquete" disabled={busy} onClick={cerrar}>✕</button>
            </div>

            <FormularioPaquete form={form} setForm={setForm} guardar={guardar} cerrar={cerrar} editId={editId} error={error} busy={busy} recintos={recintos} cargarPlano={cargarPlano} errorRecintos={errorRecintos}/>
          </div>
        </div>
      )}
    </div>
  );
}
